import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {};

export const PastSeasonReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_SELECTED_SEASON:
      return { ...state, selectedSeasonData: { ...payload } };

    case ActionTypes.SET_SELECTED_EVENT:
      return { ...state, selectedEventData: { ...payload } };

    case ActionTypes.SET_VIDEO_LIST:
      return { ...state, videoList: { ...payload } };

    case ActionTypes.SET_SELECTED_OFFSEASON_EVENT:
      return { ...state, selectedOffSeasonEvent: { ...payload } };

    case ActionTypes.DELETE_VIDEO_FROM_PAST_SEASON:
      let sortedData = Object.keys(state?.videoList?.videoArr)
        .filter(
          (item) =>
            !payload.eventMediaId.includes(state?.videoList?.videoArr[item].id)
        )
        .reduce((obj, key) => {
          obj[key] = state?.videoList?.videoArr[key];
          return obj;
        }, {});
      return {
        ...state,
        videoList: {
          ...state.videoList,
          videoArr: sortedData,
        },
      };

    case ActionTypes.UPDATE_NUMBER_OF_VIDEOS_IN_WEEKLIST:
      if (
        Object.keys(state?.selectedEventData).length &&
        state?.selectedEventData[0]?.weekName
      ) {
        const indexOfWeek = state.videoList.weekIndex;

        let removedVideoArray = state.selectedEventData[indexOfWeek][
          payload.eventType
        ].filter((item) => !payload.videoId.includes(item.id));
        state.selectedEventData[indexOfWeek][payload.eventType] =
          removedVideoArray;
        return { ...state };
      } else {
        return state;
      }

    default:
      return state;
  }
};
